import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {IOrganization} from '../data/organization/organization.model';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor(private http: HttpClient) { }

  getMyOrganizations() {
    return this.http.get<IOrganization[]>(environment.contactCenterApiBaseUrl + `v1/organizations/my`);
  }

}
